import React from 'react'
import Banner from '../components/Banner'
import Categirous from '../components/Categirous'
import OurServices from '../components/OurServices'
import Fooditems from '../components/Fooditems'

const Home = () => {
  return (
    <>
     <Banner/>
     <Categirous/>
     <Fooditems/>
     <OurServices/>
    </>
  )
}

export default Home